import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent, Grid, Icon, IconButton, Tooltip, Typography } from '@mui/material'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'
import ApplicationConf from 'conf/ApplicationConf'
import useFetch from 'common/hooks/useFetch'
import { STATUS } from 'common/constants/storeConstants'
import { toast } from 'react-toastify'
import { keys } from 'lodash'

const SUPERVISION_ROUTES = [
    { method: 'GET', path: '/api/{service}/ping', comment: 'état d\'un service (station, job, piezometer…)' },
    { method: 'GET', path: '/api/auth/ping', comment: 'état du service auth' },
    { method: 'GET', path: '/api/auth/activeUsers', comment: 'utilisateurs connectés sur l\'instance' },
    { method: 'POST', path: '/api/auth/refreshLicence', comment: 'force le rechargement de la licence' },
]

const CopyableValue = ({ label, value }) => (
    <Grid container size={12} alignItems='center' columnSpacing={1} sx={{ mb: 1 }}>
        <Grid size='grow'>
            <Typography variant='caption' sx={{ opacity: 0.7 }}>{label}</Typography>
            <Typography sx={{ fontFamily: 'monospace', wordBreak: 'break-all', fontSize: '0.8rem' }}>
                {value}
            </Typography>
        </Grid>
        <Grid size='auto'>
            <Tooltip title='Copier'>
                <IconButton
                    onClick={() => {
                        navigator.clipboard.writeText(value)
                        toast.success('Copié')
                    }}
                >
                    <Icon>content_copy</Icon>
                </IconButton>
            </Tooltip>
        </Grid>
    </Grid>
)

CopyableValue.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
}

const TestHeadersDialog = ({
    open = false,
    onClose = () => {},
}) => {
    // Le token n'est pas embarqué dans le bundle : celui-ci est téléchargeable avant
    // l'authentification Discord. Il est servi par un endpoint derrière Authorized.
    const { data, status } = useFetch(open ? ApplicationConf.testHeaders() : undefined)

    return (
        <Dialog open={open} maxWidth='md' fullWidth>
            <BasicDialogTitle onClose={onClose}>
                Tester un appel de supervision
            </BasicDialogTitle>
            <DialogContent>
                <Typography sx={{ mb: 2 }}>
                    Les routes de supervision d&apos;une instance SIEau sont protégées par le token
                    Aquaparc. Recopier cet en-tête pour les rejouer à la main (curl, Postman…).
                </Typography>

                {status === STATUS.LOADING && <Typography>Chargement…</Typography>}
                {status === STATUS.REJECTED && (
                    <Typography color='error'>
                        Impossible de récupérer le token. Vérifier que supervision-service répond.
                    </Typography>
                )}
                {status === STATUS.SUCCEEDED && (
                    <Grid container>
                        {keys(data ?? {}).map(header => (
                            <CopyableValue key={header} label={header} value={data[header]} />
                        ))}
                        <CopyableValue
                            label='Exemple curl'
                            value={`curl -H "Authorization: ${(data?.Authorization ?? '').replace(/"/g, '')}" https://<instance>/api/auth/activeUsers`}
                        />
                    </Grid>
                )}

                <Typography variant='subtitle2' sx={{ mt: 2 }}>Routes concernées</Typography>
                {SUPERVISION_ROUTES.map(route => (
                    <Typography key={route.path} component='div' sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
                        {`${route.method} ${route.path}`}
                        <Typography sx={{ fontFamily: 'inherit', fontSize: 'inherit', opacity: 0.6, display: 'inline' }}>
                            {` — ${route.comment}`}
                        </Typography>
                    </Typography>
                ))}
            </DialogContent>
        </Dialog>
    )
}

TestHeadersDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
}

export default TestHeadersDialog